import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import React, {Fragment} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {TDay} from 'stores/CreateClassStore';
import DropDownPicker from '../dropDownPicker';
import {createArrayOfTime} from 'helpers/createArrayOfTime';
import strings from '../../../translations';
import styleSheet from './styles';

export interface DaysListProps {
  timesDateData: TDay[];
  onPressAdd(value: string): void;
  onPressDelete(day: string, time: string): void;
  onDayChanged(value: string): void;
  onTimeChanged(value: string): void;
  onValueChange?(day: string, index: number, value: string): void;
}

const DaysList = (props: DaysListProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const handleAddButton = (day: string) => {
    props.onPressAdd(day);

    props.onDayChanged(day);
  };

  const handleDeleteButton = (day: string, time: string) => {
    props.onPressDelete(day, time);

    props.onTimeChanged(time);
    props.onDayChanged(day);
  };

  const arrOfTime = createArrayOfTime();

  return (
    <>
      {props.timesDateData.map((item: TDay, index: number) => {
        return (
          <Fragment key={index}>
            <View
              style={[
                styles.containerStyle,
                {zIndex: props.timesDateData.length - index},
              ]}>
              <Text style={styles.titleContainerStyle}>{item.title}</Text>

              <View style={[styles.timeContainerStyle]}>
                {item.times.map((time, idx) => (
                  <View
                    key={idx}
                    style={[
                      styles.timeCellContainerStyle,
                      {zIndex: item.times.length - idx},
                    ]}>
                    {Platform.OS !== 'web' ? (
                      <Text style={styles.timeTextStyle}>{time}</Text>
                    ) : (
                      <DropDownPicker
                        data={arrOfTime}
                        label={time}
                        onValueChange={value =>
                          props.onValueChange?.(item.day, idx, value)
                        }
                      />
                    )}

                    <TouchableOpacity
                      activeOpacity={0.7}
                      onPress={() => handleDeleteButton(item.day, time)}
                      style={styles.deleteTimeButtonStyle}>
                      <Image
                        source={theme.images.deleteIcon}
                        style={styles.deleteIconStyle}
                      />
                    </TouchableOpacity>
                  </View>
                ))}

                {Platform.OS !== 'web' && (
                  <View style={styles.greyBorderStyle} />
                )}

                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() => handleAddButton(item.day)}
                  style={styles.addTimeButtonStyle}>
                  <Image
                    source={theme.images.addIcon}
                    style={styles.addIconStyle}
                  />

                  {Platform.OS !== 'web' && (
                    <Text style={styles.addTimeButtonLabelStyle}>
                      {strings.createClassScreen.oneMoreClass}
                    </Text>
                  )}
                </TouchableOpacity>
              </View>
            </View>
          </Fragment>
        );
      })}
    </>
  );
};

export default DaysList;
